<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">{{ title }}</span>
      <v-spacer/>
      <Icon
        dataTestId="license-close"
        iconColor="white"
        icon="mdi-close"
        :small="false"
        :large="true"
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        ref="form"
        formRef="licenseForm"
        :buttonText="submitBtnText"
        @submit="saveChangesPressed"
      >
        <v-container fluid grid-list-xl>
          <v-row class="mt-1">
            <v-col cols="12">
              <span class="title">{{ $t('personalInfo') }}</span>
            </v-col>
          </v-row>
          <v-row class="mt-n3">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="license.firstName"
                data-testid="license-firstname"
                ref="firstField"
                color="black"
                maxLength="64"
                counter="64"
                :label="$t('firstName')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="license.middleName"
                data-testid="license-middlename"
                color="black"
                maxLength="64"
                counter="64"
                :label="$t('middleName')"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="license.lastName"
                data-testid="license-lastname"
                color="black"
                maxLength="64"
                counter="64"
                :label="$t('lastName')"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <span class="title">{{ $t('licenseInfo') }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="license.licenseNumber"
                data-testid="license-number"
                color="black"
                maxLength="32"
                counter="32"
                :label="$t('licenseNumber')"
                :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="license.type"
                :items="licenseTypeOptions"
                item-text="name"
                item-value="value"
                :label="$t('licenseType')"
                color="black"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="license.state"
                :items="states"
                :label="$t('state')"
                color="black"
                :rules="[rules.required]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <DatePicker
                :dateLabel="$t('issueDate')"
                :startDate="license.issueDate"
                @date-picked="license.issueDate = $event"
                dataTestId="license-issue-date"
              />
            </v-col>
            <v-col cols="12" md="4">
              <DatePicker
                :dateLabel="$t('expirationDate')"
                :startDate="license.expirationDate"
                @date-picked="license.expirationDate = $event"
                dataTestId="license-expiration-date"
              />
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import fieldRules from '@/utils/rules.js'
import { states } from '@/utils/constants.js'
import { LicenseType } from '@/utils/Enumerations'

export default {
  name: 'DriversLicenseForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue'),
    DatePicker: () => import('@/components/helper/DatePicker.vue')
  },

  props: {
    propLicense: {
      type: Object,
      default: undefined
    }
  },

  data: () => ({
    rules: fieldRules.rules,
    states,
    license: {
      firstName: '',
      middleName: '',
      lastName: '',
      licenseNumber: '',
      state: '',
      expirationDate: new Date().toISOString(),
      issueDate: new Date().toISOString(),
      type: LicenseType.ClassA.value,
      rawLicenseData: ''
    }
  }),

  computed: {
    submitBtnText () {
      return this.propLicense ? this.$t('saveChanges') : this.$t('createLicense')
    },

    title () {
      return this.propLicense ? this.$t('editingDriversLicense') : this.$t('creatingDriversLicense')
    },

    licenseTypeOptions () {
      return LicenseType.enums
    },

    isEditing () {
      return !!this.propLicense
    }
  },

  created () {
    if (this.propLicense) {
      this.license = { ...this.propLicense }
    }
  },

  mounted () {
    setTimeout(() => {
      if (this.$refs.firstField) {
        this.$refs.firstField.focus()
      }
    }, 0)
  },

  methods: {
    saveChangesPressed () {
      if (this.isEditing) {
        this.$emit('license-updated', this.license)
      } else {
        this.$emit('license-created', this.license)
      }
    }
  }
}
</script>
